import React, { useEffect } from 'react';
import PoInspector from './PoInspector';
import { useReceivingStore } from './ReceivingStore';

function PoDetailDrawer({ poId, onClose }) {
  const { pos, hydrate, loading } = useReceivingStore();
  const po = pos.find((p) => p.id === poId);

  useEffect(() => {
    if (!poId) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [poId, onClose]);

  useEffect(() => {
    if (poId && !po && !loading) {
      hydrate();
    }
  }, [poId, po, loading, hydrate]);

  if (!poId) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/30"
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className="fixed inset-y-0 right-0 z-50 flex w-full max-w-md flex-col border-l border-gray-200 bg-white shadow-2xl sm:max-w-lg lg:max-w-xl xl:max-w-2xl"
        role="dialog"
        aria-label={`PO ${poId} details`}
      >
        {loading && !po ? (
          <div className="flex flex-1 items-center justify-center text-sm text-gray-500">Loading PO…</div>
        ) : (
          <PoInspector poId={poId} onClose={onClose} />
        )}
      </aside>
    </>
  );
}

export default PoDetailDrawer;
